module.exports = __webpack_public_path__ + "static/media/arts-and-culture.9fb0042d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blocks/arts-and-culture.png
// module id = 86
// module chunks = 0